module.exports = __webpack_public_path__ + "media/images/pages/ai/photo-2-73a7655792aa0667e5019d16ebf6e17b.png";